import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-obsidian text-bone">
      <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12 lg:py-28">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
          <div className="md:col-span-6">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-bone/50">Bridge Advisors LLP</p>
            <h2 className="mt-6 max-w-xl font-serif text-4xl leading-tight tracking-tight md:text-5xl">
              Financial clarity for <span className="italic text-bone/80">complex operations.</span>
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="group mt-10 inline-flex items-center gap-3 border border-bone/30 px-7 py-4 text-sm font-medium transition-colors duration-300 hover:bg-bone hover:text-obsidian"
            >
              Start the conversation
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-bone/50">Navigate</p>
            <ul className="mt-6 space-y-3 text-bone/80">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/services" className="link-underline">Services</Link></li>
              <li><Link to="/why-bridge-advisors" className="link-underline">Why Us</Link></li>
              <li><Link to="/about" className="link-underline">About</Link></li>
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-bone/50">Contact</p>
            <ul className="mt-6 space-y-3 text-bone/80">
              <li data-testid="footer-phone">{CONTACT.phone}</li>
              <li data-testid="footer-email" className="break-all">{CONTACT.email}</li>
              <li className="text-bone/50">{CONTACT.availability}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col justify-between gap-4 border-t border-bone/15 pt-8 text-xs text-bone/40 md:flex-row">
          <span>© {new Date().getFullYear()} Bridge Advisors LLP. All rights reserved.</span>
          <span className="font-mono uppercase tracking-[0.2em]">US GAAP · Senior-level advisory</span>
        </div>
      </div>
    </footer>
  );
}
